import { v4 } from 'uuid'

import { ViewColumn, ViewData } from '@/endpoints/schemas'

import { ensureValidData } from '../helpers'

export const defaultViewData: Readonly<ViewData> = {
	columns: [],
	objectPermissions: [],
	sourceItems: [],
	sourceItemsLastId: 0,
}

export const getInitialViewData = (name: string, code = '') =>
	ensureValidData(
		{
			name,
			code,
			description: '',
			columnsLastId: 0,
		},
		defaultViewData,
	)

export const createEmptyViewColumn = (columns: ViewColumn[]): ViewColumn => ({
	id: -1,
	order: columns.length,
	name: '',
	code: '',
	uuid: v4(),
})
